import {LanguageService} from "../../serverService/languageService/LanguageService";
import {prepareRaikoSelectBoxItem, RaikoSelectBox, showServerErrorMessage} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";

export default function LanguageSelector(
    {
        handleGetInfo = (code) => {
        },
        languageId,
        setLanguageId
    }) {
    const languageService = new LanguageService();
    const [availableLanguage, setAvailableLanguage] = useState([]);
    const [availableLanguageLoadingState, setAvailableLanguageLoadingState] = useState(false);

    useEffect(() => {
        if (languageService) {
            getAvailableLanguage()
        }
    }, [])

    function getAvailableLanguage() {
        setAvailableLanguageLoadingState(true)
        languageService.getAvailableLanguageList()
            .then(response => {
                setAvailableLanguage([])

                response.map((language) => {
                    setAvailableLanguage(prevState => [
                        ...prevState,
                        prepareRaikoSelectBoxItem(language.code, language.name, "ic-translate")
                    ])
                })

                if (response.length > 0) {
                    setLanguageId(response[0].code)
                    handleGetInfo(response[0].code)
                }
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setAvailableLanguageLoadingState(false)
        })
    }

    function handleChangeSelectedLanguage(languageCode) {
        if (languageId !== languageCode) {
            setLanguageId(languageCode)
            handleGetInfo(languageCode)
        }
    }

    return (
        <RaikoSelectBox
            changeSelectItem={handleChangeSelectedLanguage}
            items={availableLanguage}
            loading={availableLanguageLoadingState}
            defaultSelectedItem={languageId}
        />
    )
}